export default {"src":"/_next/static/media/loser_left_new.89c96b97.svg","height":150,"width":240,"blurWidth":0,"blurHeight":0};